<script>
import { h, resolveDirective, withDirectives } from 'vue';

export default {
  name: 'ReportTableTooltipIcon',
  props: {
    message: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'auto bottom',
    },
    type: {
      type: String,
      default: 'info',
    },
    dataHtml: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  render() {
    if (this.message.length === 0) {
      return null;
    }

    const { message, placement, type, dataHtml, size } = this;
    let iconClasses = ['a-tooltip hi', `hi-${size}`];

    if (type === 'warning') {
      iconClasses = iconClasses.concat(['hi-important', 'text-warning']);
    } else if (type === 'danger') {
      iconClasses = iconClasses.concat(['hi-important', 'text-danger']);
    } else {
      iconClasses = iconClasses.concat(['hi-info', 'text-muted']);
    }

    const tooltip = resolveDirective('tooltip');
    const node = h('i', {
      class: iconClasses,
      title: message,
      'data-original-title': message,
      'data-html': dataHtml,
    });

    if (!tooltip) {
      return node;
    }

    return withDirectives(node, [
      [
        tooltip,
        {
          placement,
        },
      ],
    ]);
  },
};
</script>
